import React from 'react';
import './style.css'
import { Link } from 'react-router-dom';

export default class DropdownComponent extends React.Component {
    state = {
        isActive: false
    }

    constructor(props) {
        super(props);

        this.button = React.createRef()
    }

    componentWillMount = () => {
        document.addEventListener('click', this.handleClick);
    };

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClick);
    }

    handleClick = (e) => {
        if (this.button.contains(e.target)){
            this.toggleDropdown()
        } else{
            if(this.state.isActive)
                this.toggleDropdown()
        }
    }

    toggleDropdown = () => {
        this.setState({isActive: !this.state.isActive})
    }

    onClick = (option) => {
        this.toggleDropdown()
        if(option.onClick) option.onClick()
    }

    renderItem = (option, index) => {
        if(option.divider)
            return <hr key={index} className="dropdown-divider"/>

        if(option.isRoute)
            return (
                <Link key={index} className="dropdown-item"
                    onClick={() => this.onClick(option)}
                    to="/config">
                    {option.text}
                </Link>
            );
        return (
            <a key={index}
                onClick={() => this.onClick(option)}
                className="dropdown-item">
                {option.text}
            </a>
        );
    }

    render() {
        let clases = ["dropdown", "is-right", "is-desktop"]

        if(this.state.isActive)
            clases.push("is-active")

        return (
            <div className="Dropdown">
                <div className={clases.join(" ")}>
                    <div className="dropdown-trigger">
                        <button style={{color: this.props.color}}
                            // onClick={this.toggleDropdown}
                            ref={ref => this.button = ref}
                            className="button">
                            <span>{this.props.title}</span>
                            {this.props.caret &&
                            <span className="icon is-small">
                                <i className="fas fa-angle-down" aria-hidden="true"></i>
                            </span>}
                        </button>
                    </div>
                    <div className="dropdown-menu" id="dropdown-menu" role="menu">
                        <div className="dropdown-content">
                            {this.props.menu.map(this.renderItem)}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/dropdown/index.js